import { useState, useEffect } from 'react';

function useBlocksConditions(_dashboard, _variable) {
    const [listBlockConditions, setListBlockConditions] = useState([]);
    const [dashboard, setDashboard] = useState(_dashboard);
    const [variable, setVariable] = useState(_variable);
    var conditions = [];
    const createBlockCondition = () => {
        let indexBlock = listBlockConditions.length > 0 ? listBlockConditions.reduce((max, current) => {return (current.index > max) ? current.index : max }).index + 1 : 0;
        let _blocks_cond = listBlockConditions;
        _blocks_cond[_blocks_cond.length] = { conditions: [], index: indexBlock };
        setListBlockConditions([..._blocks_cond]);
    }

    const modifyBlockConditions = (newList, index, keepState = false) => {
        let res = listBlockConditions;
        for (let i = 0; i < res.length; i++) {
            if (res[i].index != index) continue;
            res[i] = { index: index, conditions: newList }
        }

        if (keepState == true){
            return res;
        }
        conditions = [...res];
        setListBlockConditions([...conditions]);
        return res;
    }

    const removeBlock = (index) => {
        let res = listBlockConditions.filter((block) => block.index !== index)
        for (let i = 0; i < res.length; i++) {
            res[i].index = i;
        }
        setListBlockConditions([...res]);
    }
    const getConditionsByBlock = (index) => {
        return listBlockConditions.find((block) => index === block.index)?.conditions;
    }

    const insertAllData = (data) => {
        setListBlockConditions(data);
    }
    const getVariables = (_dashboard = dashboard) => {
        return _dashboard.blocks.filter(block => block.type == 0).map(block => block.variables).flat().filter(variable => variable.type != 3).filter(v => v.id != variable?.id)
    }

    const setUpConditionalsList = (dashboard, variable) => {
        if (dashboard == null || variable == null) return;
        let variables = getVariables(dashboard);
        let array = [];
        for (let condition of variable.conditions) {
            let variable = variables.find(variable => variable.id == condition.variable_target_id);
            let newCond = {
                id: condition.id,
                value: condition.value,
                variable: variable,
                block_index: condition.block_index,
                index: new Date().getTime() + "_" + Math.floor(Math.random() * 100000)
            }
            array.push(newCond);
        }
        // il faut egalement triee les conditions avec et sans index 
        let cond_blocks = []
        for (let i = 0; i < array.length; i++) {
            let ind = array[i].block_index;
            if (!cond_blocks[ind]) {
                cond_blocks[ind] = { conditions: [], index: ind }
            }

            cond_blocks[ind].conditions.push(array[i]);
        };
        cond_blocks = cond_blocks.filter(cond_block => cond_block)
        insertAllData([...cond_blocks])
    }

    const createCondition = (block_index) => {
        let variable = getVariables()[0]
        let newCond = {
            value: variable.default_value,
            variable: variable,
            block_index: block_index,
            index: new Date().getTime() + "_" + Math.floor(Math.random() * 100000)
        }
        let currentsList = getConditionsByBlock(block_index) ?? []
        let newList = [...currentsList, newCond];
        return modifyBlockConditions(newList, block_index)
    }

    const modifyCondition = (block_index, condition, value) => {
        const newList = getConditionsByBlock(block_index).map(cond => {
            if (cond.index === condition.index) { // modify only the one who is given
                return { ...cond, variable: condition.variable, value: value };
            }
            return cond;

        });
        modifyBlockConditions(newList, block_index, true)
    }

    const removeCondition = (block_index, index_cond) => {
        let conds = getConditionsByBlock(block_index)
        let res = modifyBlockConditions(conds.filter((cond) => cond.index !== index_cond), block_index)
        let newConds = res.find((block) => block.index === block_index)?.conditions;

        if (newConds.length == 0) {
            removeBlock(block_index)
        }
    }


    useEffect(() => {
        if (_dashboard != null) {
            setDashboard(_dashboard)
            setUpConditionalsList(_dashboard, variable)
        }
    }, [_dashboard, _variable]);

    return { listBlockConditions, createBlockCondition, modifyBlockConditions, getConditionsByBlock, insertAllData, getVariables, createCondition, modifyCondition, removeCondition, removeBlock };
}

export default useBlocksConditions;